export enum VerificationStepsEnum {
  STEP1,
  STEP2,
  STEP3,
}

export enum SyncStatusEnum {
  NOFINISH,
  SYNCING,
  SUCCESS,
  FAIL,
}
